module.exports = __webpack_public_path__ + "static/media/WhatsApp Image 2023-11-20 at 11.31.24 AM.20d10c46.jpeg";